import axios from 'axios';
import { getFingerprint } from 'storage';

const ForgotPassword = (login) => {
  const data = { login };
  const headers = { 'Content-Type': 'application/json' };
  return axios({ method: 'post', url: '/authentication/api/v1/mortgages/forgot-password', headers, data });
};

const ForgotPasswordForOLB = (login, accountNumber, last6ssn) => {
  const data = { login, accountNumber, ssn: last6ssn };
  const headers = { 'Content-Type': 'application/json' };
  return axios({ method: 'post', url: '/authentication/api/v1/forgot-password', headers, data });
};

const ResetPasswordForOLB = (stateToken, newPassword) => {
  const data = { stateToken, newPassword };
  const headers = { 'Content-Type': 'application/json' };
  return axios({ method: 'post', url: '/authentication/api/v1/forgot-password/reset', headers, data });
};

const ForgotUsernameForOLB = (accountNumber, last6ssn) => {
  const data = { accountNumber, ssn: last6ssn };
  const headers = { 'Content-Type': 'application/json' };
  return axios({ method: 'post', url: '/authentication/api/v1/forgot-login', headers, data });
};

const SignIn = (login, password) => {
  const data = { login, password };
  const headers = { 'Content-Type': 'application/json', 'X-Device-Fingerprint': getFingerprint() };
  return axios({ method: 'post', url: '/authentication/api/v1/mortgages/sign-in', headers, data });
};

const SignUp = (firstName, lastName, email, phone, password, password2) => {
  const data = { firstName, lastName, email, phone, password, confirmPassword: password2 };
  const headers = { 'Content-Type': 'application/json', 'X-Device-Fingerprint': getFingerprint() };
  return axios({ method: 'post', url: '/authentication/api/v1/mortgages/register', headers, data });
};

export { ForgotPassword, ForgotPasswordForOLB, ForgotUsernameForOLB, ResetPasswordForOLB, SignIn, SignUp };
